import { render, staticRenderFns } from "./AxdBasicSync.vue?vue&type=template&id=5af24aa8&scoped=true"
import script from "./AxdBasicSync.vue?vue&type=script&lang=js"
export * from "./AxdBasicSync.vue?vue&type=script&lang=js"
import style0 from "./AxdBasicSync.vue?vue&type=style&index=0&id=5af24aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af24aa8",
  null
  
)

export default component.exports